import React from "react";
import { withReactAdapter } from "./withReactAdapter";
import BootstrapCSS from "./BootstrapCSS";

type LazyOptions = {
	usesBootstrap?: boolean;
	usesMoment?: boolean;
	usesReactAdapter?: boolean;
};

function Spinner() {
	return (
		<div className="m-spinner m-spinner-wide">
			<svg className="m-spinner-svg" viewBox="25 25 50 50">
				<circle
					className="m-spinner-path"
					cx="50"
					cy="50"
					r="20"
					fill="none"
					strokeWidth="1"
					strokeMiterlimit="10"
				/>
			</svg>
		</div>
	);
}

export function wrapLazyRoute(importFunc: () => Promise<any>, options: LazyOptions = {}): React.ComponentType<any> {
	const Component = React.lazy(importFunc);
	const Wrapped = props => {
		if (options.usesMoment) {
			import("./Moment").then(module => module.default());
		}

		return (
			<React.Suspense fallback={<Spinner />}>
				<BootstrapCSS usesBootstrap={options.usesBootstrap} />
				<Component {...props} />
			</React.Suspense>
		);
	};

	Wrapped.displayName = `LazyWrapped(${(Component as any).displayName || Component.name || "Component"})`;

	return options.usesReactAdapter ? withReactAdapter(Wrapped) : Wrapped;
}

export function wrapLazyComponent(importFunc: () => Promise<any>): React.ComponentType<any> {
	const Component = React.lazy(importFunc);
	const Wrapped = props => {
		return (
			<React.Suspense fallback={<Spinner />}>
				<Component {...props} />
			</React.Suspense>
		);
	};

	Wrapped.displayName = `LazyWrapped(${(Component as any).displayName || Component.name || "Component"})`;

	return Wrapped;
}
